import React, { useEffect, useState } from "react";
import axios from "axios";
import { Theme, Card, Flex, Text, Button, Separator } from "@radix-ui/themes";
import { toast } from "react-hot-toast";

import theme1 from "../assets/theme-1.jpg";
import theme2 from "../assets/theme-2.jpg";
import theme3 from "../assets/theme-3.jpg";
import theme4 from "../assets/theme-4.jpg";

import { API_URL } from "../constants/constants";

function ThemeSelector() {
  const [availableThemes, setAvailableThemes] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchThemes = async () => {
      const res = await axios.get(`${API_URL}/api/themes`);
      setAvailableThemes(res.data);
    };

    const fetchUser = async () => {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/api/user/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSelectedTheme(res.data.theme || "");
      setLoading(false);
    };

    fetchThemes();
    fetchUser();
  }, []);

  const handleSave = async () => {
    const token = localStorage.getItem("token");
    await axios.put(
      `${API_URL}/api/user/me`,
      { theme: selectedTheme },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    toast.success("Theme updated.", {
      style: {
        border: "1px solid rgb(0, 0, 0)",
        padding: "12px",
        color: "#000",
      },
      iconTheme: {
        primary: "#000",
        secondary: "#FFFAEE",
      },
    });
  };

  if (loading) return null;

  return (
    <Theme
      appearance="dark"
      accentColor="crimson"
      style={{ minHeight: "100vh" }}
    >
      <Flex
        direction="column"
        align="center"
        style={{ padding: "2rem" }}
        gap="4"
      >
        <Text size="5" weight="bold">
          Choose Your Theme
        </Text>
        <Flex wrap="wrap" gap="4" justify="center">
          {availableThemes.map((theme, index) => {
            const isActive = selectedTheme === theme.slug;

            return (
              <Card
                key={theme.slug}
                style={{
                  width: "240px",
                  padding: "1rem",
                  backgroundColor: "#1a1a1a",
                  border: isActive ? "2px solid #8B004B" : "1px solid #333",
                  borderRadius: "12px",
                  boxShadow: isActive
                    ? "0 0 12px rgba(139, 0, 75, 0.6)"
                    : "0 2px 8px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div
                  style={{
                    height: "120px",
                    backgroundColor: "#222",
                    borderRadius: "8px",
                    backgroundImage: `url(${
                      (index % 4) + 1 === 1
                        ? theme1
                        : (index % 4) + 1 === 2
                        ? theme2
                        : (index % 4) + 1 === 3
                        ? theme3
                        : theme4
                    })`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    marginBottom: "1rem",
                  }}
                />
                <Text size="3" weight="bold" align="center">
                  {theme.name}
                </Text>
                <Separator my="2" size="4" />
                <Flex justify="center">
                  {isActive ? (
                    <Button disabled variant="soft" color="crimson">
                      Current Theme
                    </Button>
                  ) : (
                    <Button onClick={() => setSelectedTheme(theme.slug)}>
                      Activate
                    </Button>
                  )}
                </Flex>
              </Card>
            );
          })}
        </Flex>
        <Button onClick={handleSave} style={{ marginTop: "2rem" }}>
          Save Theme
        </Button>
      </Flex>
    </Theme>
  );
}

export default ThemeSelector;
